import { render, staticRenderFns } from "./PrimeiraConsulta.vue?vue&type=template&id=6887554c"
import script from "./PrimeiraConsulta.vue?vue&type=script&lang=js"
export * from "./PrimeiraConsulta.vue?vue&type=script&lang=js"
import style0 from "./PrimeiraConsulta.vue?vue&type=style&index=0&id=6887554c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports